export default __webpack_public_path__ + "static/media/ceramic-header-image-mobile.4337e7ae.png";